import { Box } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import readXlsxFile from 'read-excel-file';

import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { FaCog } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetFormOptions } from "redux/formOptions";
import { createListForSingleOption, createOption } from "../createableSelect";
import PaymentCustomSelect from "components/paymentTypeSelect";
import ExcelSettingsModal from "../seprateFormComponent/excelSettings";
import { fetchAsyncGetExcelFile } from "redux/embrillProfileSlice";
import { fetchAsyncUpdateExcel } from "redux/embrillProfileSlice";
import ExcelJS from 'exceljs';
import { InputGroup } from "react-bootstrap";
import { createFormOptionApi, deleteFromOptionApi, editFromOptionApi } from "../CommonApi/form_options";
import orgJson from "components/jsonData/orgnization.json";

const ExcelComponent = ({
  getExcel,
  handleDelete,
  selectedFile,
  handleDeleteOnEdit,
  isEditing,
  role,
  expenseType,
  excelType,
  handleExcelType,
  addNewExcelOnEdit,
  excelData,
  editData
}) => {

    const formOptionsList = useSelector((state) => state.formOptions);
    const [excelTypeOption, setExcelTypeOptions] = useState([]);
    const [excelTypeValue, setExcelTypeValue] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false); 

    const [columnHeadings, setColumnHeadings] = useState([]);
    const [columnValue, setColumnValue] = useState([]);

    
    const dispatch = useDispatch();

    const handleStateUpdate = (type, setData) => {
      const typeHandlers = {
        "excel-type": () => {
          setExcelTypeValue(setData);
          handleExcelType(setData);

        },
      };
      if (typeHandlers[type]) {
        typeHandlers[type]();
      }
    };

    const createNewFormOption = async(data, type) => {
      const setData = await createFormOptionApi(data, type, dispatch, expenseType);
      if (setData) {
        handleStateUpdate(type, setData);
      }
    };
    
    const deleteFromOption = (option, type) => {
      let data = formOptionsList.find(
        (item) => item._id === option.id && item.typ === type
      );
      if (data?._id) {
        deleteFromOptionApi(dispatch, data._id).then((result) => {
          if (result.success) {
            addToast(result.message, { appearance: 'success' });
          } else {
            addToast(result.message, { appearance: 'error' });
          }
        });
      }
     
    };
    const editFormOption = (option,newValue, type) => {
      let data = formOptionsList.find(
        (item) => item._id === option.id && item.typ === type
      );
      editFromOptionApi(dispatch,data._id, newValue, expenseType).then((result) => {
        if (result.success) {
          addToast('Option edited successfully!', { appearance: 'success' });
          if (result.data) {
            handleStateUpdate(type, result.data);
            dispatch(fetchAsyncGetFormOptions())
          }
        } else {
          addToast(result.message, { appearance: 'error' });
        }
      });
  };

  const { addToast } = useToasts();
      
  const handleFileChange = (e) => {
    if (e.target.files) {
      if (e.target.files[0].size < 2 * 1024 * 1024) {
        if (isEditing) {
          addNewExcelOnEdit(e.target.files[0]);
        } else {
          getExcel(e.target.files[0]);
        }
      } else {
        addToast(orgJson.text.excelLimit, { appearance: "warning" });
      }
    }
  };
  
  const getExcelTypeOptions = ()=>{

    const typIDs = excelData && excelData.map(data => data?.typId?._id);
    let excelList = createListForSingleOption(formOptionsList, "excel-type");
    const filteredVendors = excelList.filter(exc => 
      !typIDs.includes(exc.id)
    );
    const exist = excelList.find((item)=> item?.id === excelType?.typId?._id)
    if(exist){
      setExcelTypeValue(exist)
    }
    setExcelTypeOptions(filteredVendors);
  }
  useEffect(() => {
    getExcelTypeOptions()
  }, [formOptionsList]);
 
 

  const handleOpenModal = () => {
    if (selectedFile.Key) {
      fetchExcelFile(selectedFile.Key,selectedFile?.spId); 
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };


 


  const fetchExcelFile = async (fileKey,spId) => {
    try {
      const data = {fileKey,spId}
      const response = await dispatch(fetchAsyncGetExcelFile(data)).unwrap();
     
    const file = new Blob([response.data]);
    const fileReader = new FileReader();
    fileReader.onload = async (event) => {
      const binaryStr = event.target.result;
 
      if (!binaryStr) {
        addToast(orgJson?.error?.fetchExc, { appearance: "error" });
      }
      try {
        const rows = await readXlsxFile(binaryStr);
        
        if (rows && rows.length > 0) {
          setColumnHeadings(rows[0]);
          setColumnValue(rows[1] || [])
        } else {
          throw new Error("No data found in the Excel file");
        }
 
      } catch (readError) {
        if (readError.message.includes("invalid zip file")) {
          addToast(orgJson.error.validExc, { appearance: "error" });
        } else {
          addToast(orgJson?.error?.fetchExc + readError.message, { appearance: "error" });
        }
      }
    };
    fileReader.onerror = () => {
      console.error("FileReader error:", fileReader.error);
    };
 
    fileReader.readAsArrayBuffer(file);
    } catch (error) {
      addToast(orgJson.error.notFoundExc, { appearance: "error" });
    }
  };

const fetchAndUpdateExcelFile = async (newHeading, newValues,columnsToRemove) => {
  try {
    // Fetch the existing Excel file
    const fileKey = selectedFile?.Key;
    const spId = selectedFile?.spId || ""
    const data = {fileKey,spId}

    const response = await dispatch(fetchAsyncGetExcelFile(data)).unwrap();
    const file = new Blob([response.data]);
    
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(await file.arrayBuffer());

    const worksheet = workbook.worksheets[0]; 


    if (columnsToRemove && columnsToRemove.length) {
      columnsToRemove.sort((a, b) => b - a);
      columnsToRemove.forEach(index => {
        worksheet.spliceColumns(index + 1, 1); 
      });
    }
    const firstRow = worksheet.getRow(1);
    newHeading.forEach((heading, index) => {
      firstRow.getCell(index + 1).value = heading;
    });

    const secondRow = worksheet.getRow(2);
    newValues.forEach((value, index) => {
      secondRow.getCell(index + 1).value = value; 
    });

    await saveUpdatedExcel(workbook);
  } catch (error) {
    addToast(orgJson.error.notFoundExc, { appearance: "error" });
  }
};

const saveUpdatedExcel = async (workbook) => {
  const excelBuffer = await workbook.xlsx.writeBuffer();
  const file = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
 
  const formData = new FormData();
  formData.append('file', file);
  formData.append('key', selectedFile.Key); 
  formData.append('spId', selectedFile?.spId || ""); 

  // const url = window.URL.createObjectURL(file);
  // const a = document.createElement('a');
  // a.href = url;
  // a.download = selectedFile.Key; 
  // document.body.appendChild(a);
  // a.click();
  try { 
    const res = await dispatch(
      fetchAsyncUpdateExcel({ id: editData._id, formData })
    );

    if (res?.payload) {
      addToast(orgJson.success.updatedExc, { appearance: "success" });
      handleCloseModal();
    }
  } catch (error) {
    handleCloseModal();
    addToast(orgJson.error.generic, { appearance: "error" });
  }
};

  const updateExcelSheet = (newHeading,newValue,columnsToRemove)=>{
    fetchAndUpdateExcelFile(newHeading,newValue,columnsToRemove)
  }

  return (
    <>
      <div>
        <Row>
          <Col>
          <Box display="flex" className="input-box">

            <Form.Label>Payment Type</Form.Label>
            <PaymentCustomSelect
              options={excelTypeOption}
              placeHolder={<div>Type or select...</div>}
              onChange={(newValue) => {
                setExcelTypeValue(newValue);
                handleExcelType(newValue);
              }}
              isSearchable
              onCreateOption={(e) => {
                createNewFormOption(createOption(e), "excel-type");
              }}
              disabled
              onDeleteOption={(option) => {
                deleteFromOption(option, "excel-type");
              }}
              onEditOption={(option, newValue) => {
                editFormOption(option, newValue, "excel-type");
              }}
              defaultValue={excelTypeValue}
              role={role}
              selectedFile={selectedFile}
            />
            </Box>
          </Col>
          {selectedFile.Key ? (
            <>
              <Col >
              <Box display="flex" className="input-box">

                <Form.Label>Excel Sheet Attached</Form.Label>
                  <InputGroup style={{width:'190px'}}>
                  <Form.Control
                    type="input"
                    name="excel"
                    placeholder="excel"
                    disabled

                    //   accept="application/pdf"
                    value={selectedFile.Key?.split("/").at(-1)}
                    title={selectedFile.Key?.split("/").at(-1)}
                  />
                  <InputGroup.Text>
                    <FaCog 
                      style={{
                        fontSize: "18px",
                        color: "#000D55",
                        cursor: "pointer",
                      }}
                      onClick={handleOpenModal}
                      />
                  </InputGroup.Text>
                  </InputGroup>
                   
                   
                 <Box className="mx-2">

                  <FaTrash
                      style={{
                        fontSize: "16px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={() => handleDeleteOnEdit(selectedFile.Key,selectedFile.spId)}
                    />
                 </Box>
                  </Box>
                 
               
              </Col>

              
            </>
          ) : (
            <>
              <Col>
              <Box display="flex" className="input-box">
                <Form.Label>
                  Excel Sheet Attached (<span>*</span>.xlsx)
                </Form.Label>
                <InputGroup style={{width:'250px'}}>
                  <Form.Control
                    type="file"
                    name="excel"
                    placeholder="excel"
                    disabled={!excelTypeValue?.value}
                    onChange={(e) => handleFileChange(e)}
                      accept=".xlsx"
                  />
                  </InputGroup>
                  <div className="mx-2">
                    <FaTrash
                      style={{
                        fontSize: "16px",
                        color: "red",
                        // marginTop: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleDelete()}
                    />
                  </div>
                </Box>
              </Col>
            </>
          )}
        </Row>
      </div>
      <ExcelSettingsModal 
      isOpen={isModalOpen} 
      onClose={handleCloseModal} 
      columnHeadings={columnHeadings} 
      selectedFile={selectedFile} 
      columnValue={columnValue} 
      updateExcel={updateExcelSheet}
      />

    </>
  );
};

export default ExcelComponent;
